import { render, staticRenderFns } from "./WrkServiceConfigAdd.vue?vue&type=template&id=6dbb29f1"
import script from "./WrkServiceConfigAdd.vue?vue&type=script&lang=js"
export * from "./WrkServiceConfigAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports